var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active-person"},[_c('div',{style:({ width: '100%' }),attrs:{"id":"periodChart"}}),_c('div',{staticClass:"unit"},[_vm._v(_vm._s(_vm.$t('Company'))+"："),_c('i',{staticClass:"unit_icon"}),_vm._v(_vm._s(_vm.$t('NumberOfPeople'))+"/"+_vm._s(_vm.$t('time')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }